<!--
 * @Description: 地图弹框
 * @Author: wuxuebing
 * @Date: 2024-07-11 10:29:40
 * @LastEditors: wuxuebing
 * @LastEditTime: 2024-07-16 11:03:01
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\topic-page-management\topic-page\components\map-dialog.vue
-->
<template>
  <el-dialog
    :title="mapDialog.title"
    :visible.sync="mapDialog.visible"
    :width="mapDialog.width"
    :close-on-click-modal="false"
    :before-close="mapClose"
  >
    <div class="map-input mb10" id="r-result">
      <el-input v-model="mapValue" id="suggestId" placeholder="请输入地址">
        <template slot="append"
          ><el-button @click="changeMap">搜索</el-button></template
        >
      </el-input>
    </div>

    <!-- 地图 -->
    <div id="allmap" class="map-box mb10"></div>

    <el-form
      label-width="80px"
      size="small"
      :model="mapForm"
      ref="mapForm"
      :rules="mapRules"
      label-position="left"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="公司地址" prop="address">
            <el-input
              v-model="mapForm.address"
              disabled
              placeholder="选择地点自动带出"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="详细地址" prop="detail">
            <el-input
              v-model="mapForm.detail"
              disabled
              placeholder="选择地点自动带出"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="mb10" :gutter="10">
        <el-col :span="8">
          <el-form-item label="经度" prop="longitude">
            <el-input
              v-model="mapForm.longitude"
              disabled
              placeholder="选择地点自动带出"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="纬度" prop="latitude">
            <el-input
              v-model="mapForm.latitude"
              disabled
              placeholder="选择地点自动带出"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- footer 组件 -->
    <div slot="footer" class="dialog-footer text-center">
      <el-button size="small" @click="mapClose" :loading="btnLoading"
        >取 消</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="saveMap"
        :loading="btnLoading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      mapValue: "", // 地图搜索的值
      mapDialog: {
        title: "选择公司地址",
        mode: "add",
        width: "1000px",
        visible: false,
        loading: false,
      },
      mapForm: {
        id: "", // id
        address: "", //考勤地址
        detail: "", //详细地址
        longitude: "", // 经度
        latitude: "", // 纬度
      },
      mapRules: {
        detail: [{ required: true }],
        address: [{ required: true }],
        longitude: [{ required: true }],
        latitude: [{ required: true }],
      },

      btnLoading: false,
    };
  },
  methods: {
    /********************   地图弹框   ********************/

    initMap(value) {
      this.mapValue = value ? value : "";
      this.changeMap();
    },

    // 地图变化
    changeMap() {
      let that = this;

      const map = new BMap.Map("allmap"); // 创建Map实例

      map.enableScrollWheelZoom(); //启用滚轮放大缩小，默认禁用
      map.enableContinuousZoom(); //启用地图惯性拖拽，默认禁用

      map.clearOverlays(); //清空原来的标注
      if (that.mapValue) {
        var localSearch = new BMap.LocalSearch(map);
        localSearch.setSearchCompleteCallback(function (searchResult) {
          var poi = searchResult.getPoi(0);

          map.centerAndZoom(poi.point, 15);
          // 精度赋值
          that.mapForm.longitude = poi.point.lng;
          // 纬度赋值
          that.mapForm.latitude = poi.point.lat;
          // 标题赋值
          that.mapForm.address = poi.title;
          // 详细地址赋值
          that.mapForm.detail = poi.address;

          var marker = new BMap.Marker(
            new BMap.Point(poi.point.lng, poi.point.lat)
          ); // 创建标注，为要查询的地方对应的经纬度
          map.addOverlay(marker);
        });
        localSearch.search(that.mapValue);
      } else {
        map.centerAndZoom("合肥", 15); // 初始化地图,用城市名设置地图中心点
        map.addOverlay(new BMap.Marker(new BMap.Point(117.233674, 31.826972)));
      }
    },
    // 地图关闭
    mapClose() {
      // 搜索数据为空
      this.mapValue = "";
      // 重置表单
      this.$refs.mapForm && this.$refs.mapForm.resetFields();
      this.mapDialog.visible = false;
      setTimeout(() => {
        this.btnLoading = false;
      }, 1000);
    },
    // 地图保存
    saveMap() {
      this.btnLoading = true;
      this.$refs.mapForm.validate((valid) => {
        if (!valid) {
          this.$message.warning("请输入地址进行搜索！");

          this.btnLoading = false;
          return;
        }

        this.$message.success("选择成功！");

        let arr = JSON.parse(JSON.stringify(this.mapForm));
        this.$emit("updateData", arr);
        // 关闭弹框
        this.mapClose();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.map-box {
  width: 920px;
  height: 400px;
}

.map-input {
  display: inline-block;
  width: 300px;
}
</style>